import React, { useContext } from "react";
import Ribbon from "../../Images/ribbon.png"; // adjust path as needed
import AccountCircleIcon from "../Images/Profile.svg";
import { Container } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import { capitalizeWords } from "../../helpers/commonHelper";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate } from "react-router-dom";
import { apisPath, paths } from "../../utils/path";
import { CommonContext } from "../../context/CommonContext";
import { authHttp } from "../../services/commonHttpService";

const Header = ({ showFullHeader = true }) => {
  const navigate = useNavigate();
  const { userName, userRole, logout } = useContext(AuthContext);
  const { setAlertState } = useContext(CommonContext);

  const handleLogout = async () => {
    // Show confirmation dialog before logout

    setAlertState({
      open: true,
      title: 'Are you sure you want to logout?',
      message: '',
      btnTxt: 'Yes',
      cancelBtnTxt: 'No',
      status: 'warning',
      type: 'confirm',
      onConfirm: async () => {
        // This will execute when user clicks "Yes"
        await authHttp.post(
          `${apisPath?.logOut}`
        );
        await logout();
        navigate(`${paths?.login}`);
      },
      onClose: () => {
        // This will execute when user clicks "No" - modal just closes
        console.log('Logout cancelled');
      }
    });
  };

  return (
    <Container>
      <div className="row mb-4 mt-4">
        {showFullHeader && (
          <div className="col-md-11 col-10 bg-white shadow rounded d-flex align-items-center">
            <img
              src={Ribbon}
              alt="Ribbon Logo"
              width="60"
              height="60"
              className="me-4"
            />
            <h6 className="text-tile mb-0">
              Welcome {capitalizeWords(userName)}
            </h6>
          </div>
        )}

        {/* Right Section: Profile Icon */}
        <div
          className={
            showFullHeader
              ? "col-md-1 col-2 d-flex align-items-center justify-content-center mt-2 mt-md-0"
              : "col-12 d-flex justify-content-end"
          }
        >
          {/* DROPDOWN */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="light"
              id="profile-dropdown"
              className="d-flex align-items-center"
              style={{
                background: "transparent",
                border: "none",
                boxShadow: "none",
                padding: 0,
              }}
            >
              {/* Your Image — unchanged */}
              <img src={AccountCircleIcon} alt="Profile" />

              {/* Bootstrap dropdown caret – move tight to image */}
              <span
                className="dropdown-toggle"
                style={{
                  marginLeft: "-5px", // caret ko image ke bilkul chipka diya
                  padding: 0,
                }}
              ></span>
            </Dropdown.Toggle>

            {/* Dropdown Menu */}
            <Dropdown.Menu className="custom-menu-icon">
              <Dropdown.Item
                onClick={() =>
                  navigate(
                    `${paths?.user?.commonPoint}${paths?.user?.profileView}`
                  )
                }
              >
                Profile
              </Dropdown.Item>
              {userRole === 5 &&
                <Dropdown.Item
                  onClick={() =>
                    navigate(
                      `${paths?.user?.commonPoint}${paths?.user?.hrManagement}`
                    )
                  }
                >
                  Hr Management
                </Dropdown.Item>
              }
              {/* <Dropdown.Item>Admin</Dropdown.Item> */}
              <Dropdown.Item
                className="text-danger"
                onClick={handleLogout}
              >
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Container>
  );
};

export default Header;
